import { StyleSheet } from 'aphrodite';
import { brandPrimary, darkGrayFontColor, grayIconFill, white } from '../../../../styles/colors';
import { BreakPoints, CssSelectors } from '../../../../styles/styles';

const svgStyles = CssSelectors.allChildren(
	{
		height: 20,
		width: 18,
	},
	'svg'
);
const actionButtonStyles = {
	...svgStyles,
};

export const styleSheet = StyleSheet.create({
	fullWidth: {
		width: '100%',
	},
	defaultButtonStyles: {
		...actionButtonStyles,
	},
	moreMenuContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
		justifyContent: 'flex-start',
		width: '100%',
		gap: 8,
	},
	moreMenuButton: {
		width: '100%',
	},

	keepInTouchMenu: {
		display: 'flex',
		flexDirection: 'column',
		minWidth: 150,
	},
	keepInTouchMenuItem: {
		padding: '8px 12px',
		cursor: 'pointer',
		fontSize: 13,
		color: darkGrayFontColor,
		':hover': {
			backgroundColor: '#f5f5f5',
		},
	},
	container: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'flex-start',
		width: '100%',
	},
	containerActive: {
		opacity: 1,
		pointerEvents: 'all',
	},
	actionButtonsContainer: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'flex-start',
		flex: 1,
		overflow: 'hidden',
		// This is a hack to fix the alignment of the first button so the shadow is not cut off
		height: 34,
		...CssSelectors.allChildren(
			{
				marginLeft: 2,
			},
			':first-child'
		),
	},
	actionButton: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		padding: '4px 12px',
		marginRight: 8,
		borderRadius: 3,
		cursor: 'pointer',
		backgroundColor: 'transparent',
		transition: 'background-color 0.2s',
		whiteSpace: 'nowrap',
		border: 'none',
		boxSizing: 'border-box',
		height: 32,
		':hover': {
			backgroundColor: '#f5f5f5',
		},
	},
	actionButtonEnabled: {
		opacity: 1,
		alignItems: 'center',
		background: 'none',
		borderRadius: 20,
		boxShadow: 'none',
		display: 'flex',
		marginRight: 12,
		padding: '8px 10px',
		transform: 'translate3d(0,0,0)',
		transition: 'background 0.2s, box-shadow 0.2s, transform 0.1s',
		':active': {
			boxShadow: `0 0 2px 1px rgba(0,0,0, 0.1)`,
			transform: 'translate3d(0,0,0)',
		},
		':hover': {
			background: 'white',
			transform: 'translate3d(0,-1px,0)',
			boxShadow: `0 1px 2px 1px rgba(0,0,0, 0.1)`,
		},
	},
	actionButtonIconOnly: {
		padding: '4px 8px',
	},
	actionButtonText: {
		marginLeft: 6,
		fontSize: 13,
		color: darkGrayFontColor,
		[BreakPoints.forMaxWidth(1080)]: {
			display: 'none',
		},
	},
	actionButtonDisabled: {
		opacity: 0.5,
		cursor: 'not-allowed',
		':hover': {
			backgroundColor: 'transparent !important',
			boxShadow: 'none !important',
			transform: 'translate3d(0,0,0) !important',
		},
	},
	moreButton: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		padding: '0 10px',
		height: 32,
		cursor: 'pointer',
		borderRadius: 3,
		':hover': {
			backgroundColor: '#f5f5f5',
		},
	},
	menuContainer: {
		minWidth: 150,
		backgroundColor: white,
		borderRadius: 3,
		boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
		overflow: 'hidden',
	},
	menuItem: {
		display: 'flex',
		alignItems: 'center',
		padding: '8px 12px',
		cursor: 'pointer',
		':hover': {
			backgroundColor: '#f5f5f5',
		},
	},
	menuItemDisabled: {
		opacity: 0.5,
		cursor: 'not-allowed',
		':hover': {
			backgroundColor: 'transparent',
		},
	},
	menuItemIcon: {
		marginRight: 8,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: 16,
		height: 16,
	},
	menuItemText: {
		fontSize: 13,
		color: darkGrayFontColor,
	},
	anchor: {
		display: 'inline-block',
	},
	buttonText: {
		marginLeft: 6,
		whiteSpace: 'nowrap',
		[BreakPoints.forMaxWidth(1080)]: {
			display: 'none',
		},
	},
	button: {
		opacity: 1,
		transform: 'translate3d(0,0,0)',
		transition: 'opacity 0.2s, transform 0.2s',
	},
	keepInTouch: {
		...actionButtonStyles,
		':hover:not(:disabled)': {
			boxShadow: `0 1px 2px 1px rgba(62, 139, 254, 0.4)`,
		},
	},
	sendEmail: {
		...actionButtonStyles,
		':hover:not(:disabled)': {
			boxShadow: `0 1px 2px 1px rgba(234, 129, 96, 0.4)`,
		},
	},
	sendText: {
		...actionButtonStyles,
		':hover:not(:disabled)': {
			boxShadow: `0 1px 2px 1px rgba(110, 39, 163, 0.4)`,
		},
	},
	sendCard: {
		...actionButtonStyles,
		':hover:not(:disabled)': {
			boxShadow: `0 1px 2px 1px rgba(0, 170, 232, 0.4)`,
		},
	},
	tag: {
		...actionButtonStyles,
		':hover:not(:disabled)': {
			boxShadow: `0 1px 2px 1px rgba(4, 108, 182, 0.4)`,
		},
	},
	merge: {
		...actionButtonStyles,
		':hover:not(:disabled)': {
			boxShadow: `0 1px 2px 1px rgba(242, 182, 57, 0.4)`,
		},
	},
	focus: {
		...actionButtonStyles,
		':hover:not(:disabled)': {
			boxShadow: `0 1px 2px 1px rgba(199, 93, 166, 0.4)`,
		},
	},
	export: {
		...actionButtonStyles,
		':hover:not(:disabled)': {
			boxShadow: `0 1px 2px 1px rgba(137, 201, 71, 0.4)`,
		},
	},
	more: {
		...actionButtonStyles,
		':hover:not(:disabled)': {
			boxShadow: `0 1px 2px 1px rgba(133, 133, 133, 0.4)`,
		},
	},
	exportPolicies: {
		...actionButtonStyles,
		':hover:not(:disabled)': {
			boxShadow: `0 1px 2px 1px rgba(248, 145, 67, 0.4)`,
		},
	},
	visibilityAll: {
		...actionButtonStyles,
		':hover:not(:disabled)': {
			boxShadow: `0 1px 2px 1px rgba(137, 201, 71, 0.4)`,
		},
	},
	visibilityPrivate: {
		...actionButtonStyles,
		':hover:not(:disabled)': {
			boxShadow: `0 1px 2px 1px rgba(211, 0, 13, 0.4)`,
		},
	},
	assignContactOwner: {
		...actionButtonStyles,
		':hover:not(:disabled)': {
			boxShadow: `0 1px 2px 1px rgba(62, 139, 254, 0.4)`,
		},
	},
	addConnection: {
		...actionButtonStyles,
		':hover:not(:disabled)': {
			boxShadow: `0 1px 2px 1px rgba(62, 139, 254, 0.4)`,
		},
	},
	disabled: {
		opacity: 0.4,
		pointerEvents: 'none',
	},
	noMargin: {
		margin: 0,
	},
	restoreContactText: {
		color: grayIconFill,
		textAlign: 'center',
	},
	visibilityModalContainer: {
		maxWidth: 420,
	},
	visibilityModalTextBold: {
		fontWeight: 700,
	},
	visibilityModalTextContainer: {
		color: '#0D0F11',
		fontSize: 14,
		padding: '0px 39px 0px 39px',
		textAlign: 'center',
	},
	visibilityModalTitle: {
		color: brandPrimary,
		fontSize: 18,
		paddingBottom: 9,
		paddingTop: 6,
		textAlign: 'center',
	},
});
